// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UJnA","colMin":"styles_colMin__1Ym8n"};